/** Máscara no formato do `@react-input/mask` (o `format` e o `InputMask` aceitam direto). */
export interface IMask {
    mask: string
    replacement: Record<string, RegExp>
}

// Máscaras dos campos no formato do @react-input/mask. O caractere de substituição não pode ser algo que o cliente
// digita (um "9" digitado seria lido como posição vazia), então: "_" dígito, "#" letra ou dígito.
const DIGIT = { _: /\d/ }
const ALPHANUMERIC_OR_DIGIT = { '#': /[A-Za-z0-9]/, _: /\d/ }

export const CELL_PHONE_MASK = { mask: '(__) _____-____', replacement: DIGIT } satisfies IMask
export const ZIP_CODE_MASK = { mask: '_____-___', replacement: DIGIT } satisfies IMask
export const CPF_MASK = { mask: '___.___.___-__', replacement: DIGIT } satisfies IMask
/** CNPJ alfanumérico: letras ou números nas 12 primeiras posições, dígitos verificadores numéricos. */
export const CNPJ_MASK = { mask: '##.###.###/####-__', replacement: ALPHANUMERIC_OR_DIGIT } satisfies IMask
export const CARD_MASK = { mask: '____ ____ ____ ____', replacement: DIGIT } satisfies IMask
export const AMEX_CARD_MASK = { mask: '____ ____ ____ ___', replacement: DIGIT } satisfies IMask
